import { Box, Typography } from "@mui/material";
import { formatCurrency } from "@/utils/format-currency";

export const getLedgerAccountColumns = (onView) => [
  {
    accessorKey: "accountNumber",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Account Number</div>,
    cell: ({ row }) => (
      <Typography fontSize="0.85rem" fontWeight={500} fontFamily="monospace">
        {row.original.accountNumber ?? "N/A"}
      </Typography>
    ),
  },
  {
    accessorKey: "accountName",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Account Name</div>,
    cell: ({ row }) => (
      <div
        style={{ fontSize: "0.85rem", fontWeight: 500, whiteSpace: "nowrap" }}
      >
        {row.original.accountName ?? "N/A"}
      </div>
    ),
  },
  {
    accessorKey: "accountType",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Type</div>,
    cell: ({ row }) => (
      <div style={{ fontSize: "0.85rem", whiteSpace: "nowrap" }}>
        {row.original.accountType ?? "N/A"}
      </div>
    ),
  },
  {
    accessorKey: "balance",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Balance</div>,
    cell: ({ row }) => (
      <Typography fontSize="0.85rem" fontWeight={600}>
        {row.original.balance != null
          ? formatCurrency(row.original.balance, row.original.currency ?? "NGN")
          : "N/A"}
      </Typography>
    ),
  },
  {
    accessorKey: "currency",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Currency</div>,
    cell: ({ row }) => (
      <div style={{ fontSize: "0.85rem" }}>
        {row.original.currency ?? "NGN"}
      </div>
    ),
  },
  {
    accessorKey: "status",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Status</div>,
    cell: ({ row }) => {
      const active = row.original.status === "ACTIVE";
      return (
        <Box
          sx={{
            display: "inline-flex",
            alignItems: "center",
            px: 1.5,
            py: 0.5,
            borderRadius: "999px",
            backgroundColor: active ? "#ecfdf5" : "#fef2f2",
            color: active ? "#065f46" : "#991b1b",
            fontSize: "0.78rem",
            fontWeight: 500,
            whiteSpace: "nowrap",
          }}
        >
          {active ? "Active" : "Inactive"}
        </Box>
      );
    },
  },
  {
    id: "actions",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Action</div>,
    cell: ({ row }) => (
      <Typography
        onClick={() => onView?.(row.original)}
        sx={{
          fontSize: "0.82rem",
          fontWeight: 600,
          color: "primary.main",
          cursor: "pointer",
        }}
      >
        View
      </Typography>
    ),
  },
];
